export const NAME = 'shared';

export const EmailProtocolType = {
    0: 'Pop',
    1: 'Imap'
};